var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Can't find opportunities that cater to your needs?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Use this feature to get the opportunities you want to hear about. Opt in to get notified with matching Opportunity Marketplaces.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openLink },
          },
          [_vm._v("Opportunities for African Businesses")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }